function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "_005-dashboard",
  transform: "translate(0 -52.499)"
}, React.createElement("g", {
  id: "Group_4",
  transform: "translate(0 52.499)"
}, React.createElement("g", {
  id: "Group_3"
}, React.createElement("path", {
  id: "Path_1",
  className: "st0",
  d: "M42.9 12.8c-.7-.7-1.7-.8-2.5-.2-3 2-17.8 12.1-19.3 13.7-2.3 2.3-2.3 6.1 0 8.4s6.1 2.3 8.4 0C31 33 41.1 18.2 43.1 15.3c.6-.8.5-1.9-.2-2.5zm-16.3 19c-.8.8-2 .8-2.8 0-.8-.8-.8-2 0-2.8.6-.6 4.8-3.6 10-7.2-3.6 5.2-6.5 9.4-7.2 10z"
}), React.createElement("path", {
  id: "Path_2",
  className: "st0",
  d: "M9.1 39.6l-2.4 1.2c-3.1-5.5-3.6-12-1.3-17.9l2.8 1.3c1 .5 2.2.1 2.6-.9s.1-2.2-.9-2.6l-2.8-1.3c3.5-5.7 9.5-9.5 16.2-10.1v3c0 1.1.9 2 2 2s2-.9 2-2v-3c2.3.1 4.6.7 6.7 1.7 1 .4 2.2 0 2.6-1s0-2.2-1-2.6C22.9 1.7 8 7.3 2.2 20c-3.6 8-2.8 17.2 2 24.5.5.8 1.6 1.1 2.5.7l4-2c1-.5 1.4-1.7.9-2.6-.3-1.1-1.5-1.5-2.5-1z"
}), React.createElement("path", {
  id: "Path_3",
  className: "st0",
  d: "M48.3 20.1c-.4-1-1.6-1.4-2.6-1-1 .4-1.4 1.6-1 2.6 2.8 6.1 2.5 13.2-.8 19.1l-2.5-1.2c-1-.5-2.2-.1-2.6.9-.5 1-.1 2.2.9 2.6l4.1 2c.9.4 1.9.1 2.5-.7 4.8-7.2 5.5-16.4 2-24.3z"
}))));

var SvgIcnDashboard = function SvgIcnDashboard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    viewBox: "0 0 50.5 50.5",
    fill: "#fff",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcnDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_dashboard.6ac11ce2.svg";
export { ForwardRef as ReactComponent };